<template>
  <el-container direction="vertical" class="form-wrapper el-form--label-top">
    <el-row :gutter="20">
      <el-col :span="24">
        <h1 class="big-heading">{{ $t("thankYou.heading") }}</h1>
        {{ $t("thankYou.message") }}
      </el-col>
    </el-row>
  </el-container>
</template>

<script lang="ts" setup>
import {onMounted} from "vue";

onMounted(() => {
  if ((window as Window & typeof globalThis & {dataLayer: any}).dataLayer) {
    (window as Window & typeof globalThis & {dataLayer: any}).dataLayer.push({'event': 'calc_sent'});
  }
})

</script>
